import { createSelector } from 'reselect';
import {
  ColumnsEntities,
  ColumnsState
} from './columns.reducer';

export const getColumnsState = (state): ColumnsState => {
  return state.columns;
};

export const getColumnsEntities = createSelector(
  getColumnsState,
  (state: ColumnsState) => {
    return state.entities;
  }
);

export const getColumns = createSelector(
  getColumnsEntities,
  (entities: ColumnsEntities) => Object.keys(entities)
    .map((threadId) => entities[threadId])
);

